import React from 'react';
import { Helmet } from 'react-helmet';

interface SeoProps {
  title: string;
  description: string;
  canonicalUrl: string;
  ogImage?: string;
  ogType?: string;
  location?: string;
}

const Seo: React.FC<SeoProps> = ({
  title,
  description,
  canonicalUrl,
  ogImage = '',
  ogType = 'website',
  location = 'Cupertino, CA',
}) => {
  if (description.length > 160) {
    if (typeof window !== 'undefined') {
      console.warn('Meta description is too long (over 160 characters).');
    }
  }
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description.slice(0, 160)} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Local SEO Meta Tags */}
      <meta name="geo.region" content="US-CA" />
      <meta name="geo.placename" content={location} />
      <meta name="geo.position" content="37.322998;-122.032182" />
      <meta name="ICBM" content="37.322998, -122.032182" />
      
      {/* Open Graph tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description.slice(0, 160)} />
      <meta property="og:type" content={ogType} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content="Pacifica Dental" />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description.slice(0, 160)} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Additional SEO tags */}
      <meta name="keywords" content={`dentist in ${location}, chinese dentist near me, recommended dentist in ${location}, family dentist, cosmetic dentist, emergency dentist`} />
      <meta name="author" content="Pacifica Dental" />
      <meta name="robots" content="index, follow" />
    </Helmet>
  );
};

export default Seo; 